export default __webpack_public_path__ + "static/events-dark-684b55218779bf504cf324884ab32b60.png";